export default __webpack_public_path__ + "static/media/wrong-tick.b3cce67d.svg";